import { render, staticRenderFns } from "./PerAppointExpertModal.vue?vue&type=template&id=b0dd2a98&scoped=true"
import script from "./PerAppointExpertModal.vue?vue&type=script&lang=js"
export * from "./PerAppointExpertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd2a98",
  null
  
)

export default component.exports